import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface AmortizationSummary {
  date_effet: string;
  montant_deja_paye: number;
  montant_restant: number;
  capital_restant_du: number;
  assurance_deja_payee: number;
  assurance_restante: number;
}

export interface AmortizationMeta {
  banque_detectee?: string | null;
  currency?: string | null;
  capital_initial?: number | null;
  duree_mois?: number | null;
}

export interface AmortizationAnalysisResponse {
  rows: any[];
  summary?: AmortizationSummary | null;
  meta: AmortizationMeta;
}

export interface InsurerQuoteResult {
  assureur?: string | null;
  label: string;
  montant_total: number;
  montant_mensuel?: number | null;
  contribution_type?: string | null;
  currency: string;
}

@Injectable({
  providedIn: 'root'
})
export class AmortissementService {
  // 🎯 Maintenant intégré dans CAC (même serveur, port 8000)
  private baseApiUrl = `${environment.apiUrl}/api`;
  private analyzeUrl = `${this.baseApiUrl}/amortization/analyze`;
  private analyzeInsurerQuoteUrl = `${this.baseApiUrl}/amortization/insurer-quote/analyze`;

  constructor(private http: HttpClient) {}

  analyzeAmortization(
    file: File,
    dateEffet: string,
    banque?: string | null
  ): Observable<AmortizationAnalysisResponse> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('date_effet', dateEffet);
    if (banque) {
      formData.append('banque', banque);
    }

    const headers = this.buildAuthHeaders();

    return this.http.post<AmortizationAnalysisResponse>(this.analyzeUrl, formData, {
      headers
    });
  }

  analyzeInsurerQuote(
    file: File,
    assureurHint?: string | null
  ): Observable<InsurerQuoteResult> {
    const formData = new FormData();
    formData.append('file', file);
    if (assureurHint) {
      formData.append('assureur_hint', assureurHint);
    }

    const headers = this.buildAuthHeaders();

    return this.http.post<InsurerQuoteResult>(this.analyzeInsurerQuoteUrl, formData, {
      headers
    });
  }

  private buildAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('access_token');
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  }
}
